module.exports = __webpack_public_path__ + "media/images/basic_logos/close-dae17127e87a30f6e63653985dca1891.svg";